import mock from '../mock'

// ** Utils
import { paginateArray } from '../utils'

const data = {
  permissions: [
    {
      id: 1,
      name: 'All',
      assignedTo: ['all'],
      actions: 'Access all modules',
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 2,
      assignedTo: ['masteradmin', 'admin', 'manager', 'hr', 'developer', 'logistics', 'transportation'],
      name: 'All Employees',
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 3,
      name: 'Customer',
      assignedTo: ['masteradmin', 'customer'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 4,
      name: 'Admin',
      assignedTo: ['masteradmin', 'admin'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 5,
      name: 'Manager',
      assignedTo: ['masteradmin', 'admin', 'manager'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 6,
      name: 'HR',
      assignedTo: ['masteradmin', 'hr'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 7,
      name: 'Developer',
      assignedTo: ['masteradmin', 'developer'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 8,
      name: 'Any',
      assignedTo: ['masteradmin', 'any'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 9,
      name: 'Logistics',
      assignedTo: ['masteradmin', 'admin', 'logistics'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 10,
      name: 'CRM',
      assignedTo: ['masteradmin', 'sales', 'admin', 'logistics', 'manager'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 11,
      name: 'Add User',
      assignedTo: ['masteradmin', 'hr', 'admin', 'logistics', 'manager', 'transportation'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 12,
      name: 'View User',
      assignedTo: ['masteradmin', 'hr', 'admin', 'logistics', 'manager', 'transportation'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 13,
      name: 'List User',
      assignedTo: ['masteradmin', 'hr', 'admin', 'logistics', 'manager', 'transportation'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 14,
      name: 'Any Limited',
      assignedTo: ['masteradmin', 'any', 'limited'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 15,
      name: 'FF Customer',
      assignedTo: ['masteradmin', 'freightforward customer'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 16,
      name: 'Reports',
      assignedTo: ['masteradmin', 'manager', 'admin', 'logistics'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 17,
      name: 'Cron Jobs',
      assignedTo: ['cronjobs'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 18,
      name: 'Transportation',
      assignedTo: ['masteradmin', 'admin', 'transportation'],
      createdDate: '14 Apr 2022, 8:43 PM'
    },
    {
      id: 19,
      name: 'Driver',
      assignedTo: ['masteradmin', 'admin', 'driver'],
      createdDate: '14 Apr 2022, 8:43 PM'
    }
  ]
}

// ------------------------------------------------
// GET: Return Permissions List
// ------------------------------------------------
mock.onGet('/apps/permissions/data').reply(config => {
  const { q = '', perPage = 10, page = 1, assignedTo = '' } = config.params
  const queryLowered = q.toLowerCase()
  const filteredData = data.permissions.filter(permission => {
    if (assignedTo !== '') {
      return (
        (permission.name.toLowerCase().includes(queryLowered) ||
          permission.createdDate.toLowerCase().includes(queryLowered)) &&
        permission.assignedTo.includes(assignedTo)
      )
    } else {
      return (
        permission.name.toLowerCase().includes(queryLowered) ||
        permission.createdDate.toLowerCase().includes(queryLowered)
      )
    }
  })

  return [
    200,
    {
      params: config.params,
      allData: data.permissions,
      total: filteredData.length,
      permissions: paginateArray(filteredData, perPage, page)
    }
  ]
})

// POST: Add new permission
mock.onPost('/apps/permissions/add-permission').reply(config => {
  // Get permission from post data
  const permission = JSON.parse(config.data).permission

  const { length } = data.permissions
  let lastIndex = 0
  if (length) {
    lastIndex = data.permissions[length - 1].id
  }
  permission.id = lastIndex + 1

  permission.assignedTo = ['masteradmin']

  const now = new Date()
  const months = now
    .toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
    .replace(',', '')
  const time = now.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

  const monthsArr = months.split(' ')
  /*eslint-disable */
  const moveElement = (array, sourceIndex, destinationIndex) => {
    return array.map(a =>
      a === sourceIndex
        ? array.find(a => a === destinationIndex)
        : a === destinationIndex
        ? array.find(a => a === sourceIndex)
        : a
    )
  }

  const finalDate = moveElement(monthsArr, monthsArr[0], monthsArr[1]).join(' ')

  permission.createdDate = `${finalDate}, ${time}`

  data.permissions.unshift(permission)

  return [201, { permission }]
})

mock.onPost('/apps/permissions/update-permission').reply(config => {
  // Get permission from post data
  const { id, name } = JSON.parse(config.data)

  data.permissions.find(i => {
    if (i.id === id) {
      i.name = name
    }
  })

  return [201]
})

// DELETE: Deletes Permissions
mock.onDelete('/apps/permissions/delete').reply(config => {
  // Get  id from URL
  let permissionID = config.id

  // Convert Id to number
  permissionID = Number(permissionID)

  const permissionIndex = data.permissions.findIndex(t => t.id === permissionID)
  data.permissions.splice(permissionIndex, 1)

  return [200]
})
